<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1 v-b-modal.select-update-dialog>Lịch làm việc (AFS)</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="canCreate()"
          @click="$router.push('/calendar-afs/create')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="canExport()"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
        <button
          @click="exportReport"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="canExport()"
        >
          <i class="bx bx-download"></i> Xuất báo cáo
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keyword"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="dataStaff" placeholder="Người xử lý">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainRegionId"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng của người xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.handlerMainProvinceId"
              :options="dataProvinceMC"
              placeholder="Tỉnh của người xử lý"
              :disabled="!search.handlerMainRegionId || search.handlerMainRegionId === '0'"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.purposes"
              :options="optionsPurpose"
              :settings="{ placeholder: 'Tên công việc' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng công việc:<strong class="text-primary">&nbsp;{{ statistical.total }}</strong>
            &nbsp;&nbsp;| &nbsp;&nbsp; Mới tạo:<strong class="text-primary"
              >&nbsp;{{ statistical.new }}</strong
            >
            &nbsp;&nbsp;| &nbsp;&nbsp; Đang xử lý:<strong class="text-primary"
              >&nbsp;{{ statistical.process }}</strong
            >
            &nbsp;&nbsp;| &nbsp;&nbsp; Đã xử lý:<strong class="text-primary"
              >&nbsp;{{ statistical.finish }}</strong
            >
            &nbsp;&nbsp;| &nbsp;&nbsp; Đã hủy:<strong class="text-primary"
              >&nbsp;{{ statistical.cancel }}</strong
            >
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTask"
              :fields="filterTable"
              selectable
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <div>
                  <b>Tạo: </b>{{ data.item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}<br />
                </div>
                <div v-if="showTimeEstimate(data.item)">
                  <b>Dự kiến: </b>
                  {{ data.item.startIntend | formatDate('HH:mm, DD/MM/YYYY') }}
                  -- {{ data.item.endIntend | formatDate('HH:mm, DD/MM/YYYY') }}<br />
                </div>
                <div v-if="showTimeProcessing(data.item)">
                  <b>Xử lý: </b>
                  {{ data.item.startProcessing | formatDate('HH:mm, DD/MM/YYYY') }}
                  --
                  {{ data.item.endProcessing | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
                <div v-if="showTimeUpdate(data.item)">
                  <b>Cập nhật: </b>
                  {{ data.item.dateEdit | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
              </template>
              <template #cell(task)="data">
                <b>Tên công việc:</b>
                {{ data.item.purposeStrings | transformData(dataNameCalendar) }}
                <br />
                <div v-if="data.item.status !== 'NEW'">
                  <b>Kết quả: </b>
                  <span>{{ data.item.result | fomatResultNameAFS }}</span>
                </div>
              </template>
              <template #cell(merchant)="data">
                <b>{{ data.item.customerInfoRes && data.item.customerInfoRes.merchantName }}</b
                ><br />
                <a href="mailto:">{{
                  data.item.customerInfoRes && data.item.customerInfoRes.email
                }}</a>
                <br />
              </template>
              <template #cell(handler)="data">
                <b>{{ data.item.handlerRes && data.item.handlerRes.name }}</b>
                <br />
                <a href="mailto:">{{ data.item.handlerRes && data.item.handlerRes.userName }}</a>
              </template>
              <template #cell(creator)="data">
                <div>
                  <b>Người tạo: </b>
                  {{ data.item.creatorInfo && data.item.creatorInfo.name }}
                </div>
                <br />
                <div>
                  <b>Nguồn tạo: </b>
                  <span>{{ data.item.informSource | fomatCreatorAFS }}</span>
                </div>
                <br />
                <div>
                  <b>Hình thức: </b>
                  <span>{{ data.item.inform | fomatCreatoByAFS }}</span>
                </div>
              </template>
              <template #cell(operationType)="data">
                <span
                  v-if="data.item.operationType !== null && data.item.operationType"
                  class="badge"
                  :class="[data.item.operationType ? data.item.operationType : 'WAITING']"
                >
                  {{ data.item.operationType | transformData(Config.statusJob) }}
                </span>
                <p v-if="data.item.operationType === 'REJECT'">
                  Lý do từ chối: {{ data.item.rejectNote }}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusCalendarAfs) }}
                </span>
              </template>
              <template #cell(isMcUploadPhoto)="data">
                <span
                  v-if="showIsMcUploadedPhoto(data.item.purposes, data.item.isMcUploadPhoto)"
                  class="badge badge-success"
                  >Đã upload</span
                >
                <span
                  v-if="canCoppy(data.item.purposes, data.item.isMcUploadPhoto)"
                  class="badge badge-warning"
                  >Chưa upload</span
                >
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button
                    class="dropdown-item"
                    v-if="canDetail()"
                    @click="onRowSelected(data.item)"
                  >
                    <i class="bx bx-detail"></i>Chi tiết
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canEdit(data.item.status)"
                    @click="calendarEdit(data.item)"
                  >
                    <i class="bx bx-edit-alt"></i> Sửa
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canCoppy(data.item.purposes, data.item.isMcUploadPhoto)"
                    @click="copyLink(data.item.id)"
                  >
                    <i class="bx bx-edit-alt"></i> Copy link YC bổ sung GPDKKD
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canUpdate(data.item.status)"
                    @click="calendarUpdate(data.item)"
                  >
                    <i class="bx bx-edit-alt"></i> Cập nhật
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canCancel(data.item.status)"
                    @click="calendarCancel(data.item)"
                  >
                    <i class="bx bx-trash-alt"></i> Hủy
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canCancelBonus(data.item.status)"
                    @click="calendarCancelBonus(data.item)"
                  >
                    <i class="bx bx-trash-alt"></i> Hủy
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <!-- --Modal xuất file báo cáo-- -->
    <b-modal id="modal-scoped" v-model="modalExportReport">
      <template #modal-header="{ close }">
        <h5>Xuất file báo cáo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <datepicker
          placeholder="Chọn tháng"
          format="MM/yyyy"
          :language="vi"
          :minimumView="'month'"
          :maximumView="'year'"
          :initialView="'year'"
          v-model="dateReport"
          :disabledDates="disabledFn"
        ></datepicker>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="downloadReport()"> Xuất bảo cáo </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <UpdateAFS
      :dataUpdate="dataUpdate"
      :purposesSelected="purposesSelected"
      :fileImage="fileImage"
      :dateRangeProcessing="dateRangeProcessing"
      @updateCalendar="updateCalendar"
      @onHidden="onHidden"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import { v4 as uuidv4 } from 'uuid'
  import UpdateAFS from '@/components/UpdateAFS.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian' },
    { key: 'task', label: 'Công việc' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'handler', label: 'Người xử lý' },
    { key: 'creator', label: 'Người tạo' },
    { key: 'operationType', label: 'Trạng thái duyệt' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'isMcUploadPhoto', label: 'YC bổ sung GPDKKD' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'calendarAFS',
    components: {
      UpdateAFS,
    },
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        userData: JSON.parse(localStorage.getItem('userData')),
        search: {
          handlerMainProvinceId: '',
          handlerMainRegionId: '',
          page: 1,
          size: 20,
        },
        pagination: {
          total: 0,
        },
        dataTask: [],
        statistical: {},
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataStaff: [],
        optionsPurpose: Config.jobPurposes,
        dataStatus: Config.statusCalendarAfs,
        dataResult: Config.resultCalendarAfs,
        update: {},
        dateRangeProcessing: {
          startProcessingDate: null,
          endProcessingDate: null,
        },
        resonArr: [],
        purposesSelected: null,
        modalExportReport: false,
        loading: true,
        showLoading: false,
        vi: vi,
        dateReport: '',
        disabledFn: {
          from: new Date(
            Number(new Date().getFullYear()),
            Number(new Date().getMonth()),
            Number(new Date().getDate()) > 25 ? 25 : 0
          ),
        },
        fileImage: [],
        dataUpdate: {},
        dataNameCalendar: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
      }
    },
    mounted() {
      StaffService.getStaffByIdSuperior({ userId: this.userData.userId })
        .then(
          s =>
            s.data?.map(s => ({
              id: s.userId,
              text: `${s.name} - ${s.userName}`,
            })) ?? []
        )
        .then(s => (this.dataStaff = s))
      CalendarAfsService.catCalendar({ size: 100, page: 1 })
        .then(s => s.data?.map(s => ({ id: s.taskCode, text: s.taskName })) ?? [])
        .then(s => (this.dataNameCalendar = s))
      this.fetchData()
      this.getMcRegions()
    },
    watch: {
      'search.size': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
    },
    methods: {
      async queryMcProvince(e) {
        try {
          this.search.handlerMainProvinceId = ''
          this.dataProvinceMC = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
                newId: e.id,
              }
            })
            this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      async getMcRegions() {
        const data = await StaffService.getListRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
              code: e.code,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },

      // getM (check) {

      // },
      onRowSelected(item) {
        if (this.dataPermission.includes('CNPS_CALENDAR_AFS_DETAIL')) {
          window.open(`/calendar-afs/detail/${item.id}`, '_blank')
        }
      },
      async exportExcel() {
        try {
          if (!this.search.fromDate || !this.search.toDate || !this.search.saleId) {
            this.showFailMx('Bạn cần lọc theo thời gian và người xử lý')
            return
          }
          this.showLoading = true
          await CalendarAfsService.exportExcelCalendarAFS(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      exportReport() {
        this.modalExportReport = true
      },

      // download bao cao
      async downloadReport() {
        const data = {
          month: Number(moment(this.dateReport).format('MM')),
          year: Number(moment(this.dateReport).format('YYYY')),
        }
        try {
          this.showLoading = true
          await CalendarAfsService.exportReportCalendarAFS(data)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.modalExportReport = false
        }
      },
      // chuyển trang sửa
      calendarEdit(item) {
        if (
          item.creatorInfo?.userName === this.userData?.username ||
          item.handlerRes?.userName === this.userData?.username
        ) {
          this.$router.push({ path: `/calendar-afs/edit/${item.id}` })
        } else {
          this.showFailMx('Bạn không có quyền thực hiện thao tác này')
        }
      },
      // lấy list nv afs
      // define ngày trên lịch
      transformDate() {
        this.search.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          size: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      copyLink(id) {
        navigator.clipboard.writeText(
          `${window._env_?.VUE_APP_BASE_URL ?? process.env.VUE_APP_BASE_URL}/mc-dkkd/${id}`
        )
        this.showSuccessMx('Copy link thành công')
      },

      // cập nhật
      calendarUpdate(item) {
        this.dataUpdate = {}
        if (item.handlerRes.userName === this.userData.username) {
          this.onChangeType(item.type)
          this.dataUpdate.id = item.id
          this.dataUpdate.selectedStt = item.status
          this.dataUpdate.selectedResult = item.result
          this.dataUpdate.noteUpdate = item.note
          this.dataUpdate.noteUpdateArr = item.note?.split(', ')
          this.dataUpdate.noteUpdateType = item.type
          this.dataUpdate.noteDes = item.description
          this.dataUpdate.saleOfflineSignedImage = item.saleOfflineSignedImage
          this.dateRangeProcessing = {
            startDate: item.startIntend,
            endDate: item.endIntend,
          }
          const mappingData = (arr, type) =>
            arr.forEach(url => {
              const ar = { name: url, url, type, id: uuidv4() }
              this.fileImage.push(ar)
            })
          mappingData(item.images, 'images')
          this.purposesSelected = item.purposes?.[0] ?? null
          setTimeout(() => {
            this.$bvModal.show('select-update-dialog')
          }, 500)
        } else {
          this.showFailMx('Bạn không có quyền thực hiện thao tác này')
        }
      },

      // Dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          const data = await CalendarAfsService.getTaskAFS({
            ...this.search,
            ...(this.search.handlerMainProvinceId &&
              this.search.handlerMainProvinceId !== '0' && {
                handlerMainProvinceId: this.dataProvinceMC.find(
                  item => item.id === this.search.handlerMainProvinceId
                ).newId,
              }),
          })
          if (data.success) {
            this.dataTask = data.data.wkcldrasList
            this.pagination.total = data.totalPage?.total ?? 0
            this.statistical = {
              total: data.data?.total ?? 0,
              new: data.data?.totalNew ?? 0,
              process: data.data?.totalProcessing ?? 0,
              cancel: data.data?.totalCancel ?? 0,
              finish: data.data?.totalFinished ?? 0,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async onChangeType(data) {
        const res = mxItemAction.onChangeType(data)
        res.then(result => {
          this.dataUpdate.resonArr = result
        })
      },

      async updateCalendar(data) {
        try {
          this.showLoading = true
          const res = await CalendarAfsService.UpdateCalendarAFS(data)
          if (res.success) {
            this.showSuccessMx(res.message)
            this.fetchData()
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.onHidden()
          this.$bvModal.hide('select-update-dialog')
        }
      },
      onHidden() {
        this.fileImage = []
        this.dataUpdate = {}
        this.purposesSelected = ''
        this.dateRangeProcessing = {}
        this.dataUpdate.noteUpdateArr = []
      },
    },
  }
</script>
<style scoped>
  .wrapper-cancel {
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
    padding: 0 15px;
  }
  .NEW {
    color: #fff;
    background-color: #6c757d !important;
  }
</style>
